export default __webpack_public_path__ + "static/media/airlockz-wht-banner-1.ca7a623e.jpg";